module.exports = __webpack_public_path__ + "img/profitable-img-8.4dba0af8.png";